import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { getAnalytics, usTimezone } from "../Utils/utils";
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import Loaderspinner from "../../components/Loader";
import { Tooltip } from 'react-tooltip'

const AnalyticsDetail = () => {
    const location = useLocation();

    const [showSidebar, setShowSidebar] = useState(false);
    const [loading, setLoading] = useState(false)
    const [analyticsList, setAnalyticsList] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");

    const { reference_id, type, event, breadcrumbs } = location.state || {};

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search]);

    const fetchList = async () => {
        try {
            setLoading(true);
            const limit = 10;
            const offset = page * limit;

            const response = await getAnalytics({ reference_id, type, event, search, limit, offset });

            if (response?.status == 200) {
                setAnalyticsList(response?.data?.rows);
                if ((response?.data?.count || 0) < limit) {
                    setTotalPages(page + 1);
                } else {
                    setTotalPages(page + 2);
                }
            } else {
                console.log("cannot fetch analytics detail", response)
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />

                        <div className="header header-bg pb-6">
                            <div className="container-fluid">
                                <div className="header-body">
                                    <div className="row align-items-center py-4">
                                        <div className="col-lg-6 col-7">
                                            <nav
                                                aria-label="breadcrumb"
                                                className="d-none d-md-inline-block ml-md-4"
                                            >
                                                <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                    <li className="breadcrumb-item">
                                                        <Link to="/dashboard">
                                                            <i className="fas fa-home" />
                                                        </Link>
                                                    </li>
                                                    <li className="breadcrumb-item">
                                                        <Link to="/resources">
                                                            <span className="" style={{ color: "#f6f9fc", fontSize: "14px" }}>Resources</span>
                                                        </Link>
                                                    </li>
                                                    {breadcrumbs?.map((item, index) => (
                                                        item.path ? (
                                                            <li key={index} className="breadcrumb-item">
                                                                <Link to={item.path}>
                                                                    <span style={{ color: "#f6f9fc", fontSize: "14px" }}>
                                                                        {item.label}
                                                                    </span>
                                                                </Link>
                                                            </li>
                                                        ) : (
                                                            <li key={index} className="breadcrumb-item mt-2">
                                                                <span style={{ color: "#f6f9fc", fontSize: "14px" }}>
                                                                    {item.label}
                                                                </span>
                                                            </li>
                                                        )
                                                    ))}

                                                    <li className="breadcrumb-item mt-2">
                                                        <span className="" style={{ color: "#f6f9fc", fontSize: "14px" }}>
                                                            {event == 'visit_site' ? "Visits" : event == 'connect' ? 'Connect' : 'Views'}
                                                        </span>
                                                    </li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <div className="row ">
                                                    <h5 className="mb-0 w-auto">Resources</h5>
                                                    <p
                                                        className="w-auto px-0"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content="A complete list of all resources available on the platform. Use this section to review resource details, manage visibility, track engagement metrics, and ensure content accuracy."
                                                        data-tooltip-place="right"
                                                    >
                                                        <i className="fas fa-info-circle" />

                                                    </p>

                                                    <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                                                </div>
                                                {/* <div className="d-flex align-items-center">
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Email</th>
                                                        <th>Phone</th>
                                                        <th>Clicked At</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {analyticsList?.length > 0 ? (
                                                        analyticsList.map((analytics, index) => (
                                                            <tr key={index}>
                                                                <td>{`${analytics?.user?.about?.name} ${analytics?.user?.about?.lastname}`}</td>
                                                                <td>{analytics?.user?.email}</td>
                                                                <td>{analytics?.user?.phone}</td>
                                                                <td>{usTimezone(analytics?.created_at)}</td>
                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Row>
                                <Col xs={12}>
                                    <div className='paginate-css'>
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                </div>
            </div>
        </>

    )
}
export default AnalyticsDetail;